import { call, put, take } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { statusCodeIsBelow400 } from '../helpers/utility'
import api from '../api/api'
import {
  FETCH_LEVELS_REQUEST,
  FETCH_LEVELS_SUCCESS,
  FETCH_LEVELS_FAIL,
} from '../actions/actions'

export function* fetchLevels() {
  while (true) {
    yield take(FETCH_LEVELS_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(fetchLevelsApiCall)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_LEVELS_SUCCESS,
          levels: data.levels,
        })
      } else {
        yield put({
          type: FETCH_LEVELS_FAIL,
          error: general_errors,
        })
      }
    } catch (error) {
      yield put({
        type: FETCH_LEVELS_FAIL,
        error,
      })
    }
  }
}

function* fetchLevelsApiCall(token) {
  for (let i = 0; i < 3; i++) {
    try {
      const response = yield call(api.fetchLevels, token)
      return response
    } catch (error) {
      if (i < 2) {
        yield call(delay, 1000) //recall api after 1 sec
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/levelsSaga.js